// import CryptoJS from 'crypto-js'

export async function chkConnectToMetamask() {
  try {
    if (window.ethereum) {
      let address = await window.ethereum.request({
        method: 'eth_accounts',
      })
      return address
    } else {
      return Promise.reject('Metamask is not installed')
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

export async function connectToMetamask(para) {
  try {
    if (window.ethereum) {
      switch (para) {
        case 'Metamask':
          if (!window.ethereum.isMetaMask || window.ethereum.isTokenPocket) {
            return Promise.reject('Metamask is not installed')
          }
          break
        case 'TokenPocket':
          if (!window.ethereum.isMetaMask || !window.ethereum.isTokenPocket) {
            return Promise.reject('TokenPocket is not installed')
          }
          break
      }
      let address = await window.ethereum.request({
        method: 'eth_requestAccounts',
      })
      return address
    } else {
      return Promise.reject('Metamask is not installed')
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

export async function disconnectToMetamask() {
  try {
    if (window.ethereum) {
      let result = await window.ethereum.request({
        method: 'eth_requestAccounts',
        params: [
          {
            eth_accounts: {},
          },
        ],
      })
      return result
    } else {
      return Promise.reject('Metamask is not installed')
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

export async function switchChain(chainId) {
  try {
    if (window.ethereum) {
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId }],
      })
      return true
    } else {
      return Promise.reject('Metamask is not installed')
    }
  } catch (err) {
    return Promise.reject(err)
  }
}

export async function getChainId() {
  try {
    if (window.ethereum) {
      let chainId = await window.ethereum.request({
        method: 'eth_chainId',
      })
      return chainId
    } else {
      return Promise.reject('Metamask is not installed')
    }
  } catch (err) {
    return Promise.reject(err)
  }
}
